import { features, stats } from '@/mocks/movies';

export default function FeaturesSection() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <h3 className="text-xl md:text-3xl font-heading text-foreground-100 mb-3">
            为什么选择奇优影院
          </h3>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            我们致力于为用户提供最优质的在线观影体验，让每一帧画面都流畅呈现
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-12 md:mb-16">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-300/20 hover:border-primary-500/30 transition-colors group"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500 mb-4 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h4 className="text-base font-medium text-foreground-200 mb-2">
                {feature.title}
              </h4>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 py-8 px-4 md:px-10 rounded-lg bg-background-100 border border-background-300/20">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-primary-500 mb-1">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-500">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}